<span class="u_capitalize" [ngClass]="{ 'text-success': billingUtils.isActive(subscription), 'text-danger': billingUtils.isSuspended(subscription) || billingUtils.isCancelled(subscription) }">
  {{ subscription.status === 'non_renewing' ? 'active' : subscription.status }}
</span>